function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { SvgIcon } from '@material-ui/core';
export default function WEIcon(props) {
  let output = /*#__PURE__*/React.createElement(SvgIcon, _extends({
    viewBox: "0 0 1024 1024"
  }, props), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M444.101 826.801h-104.172l-72.189-475.172-73.103 475.172h-106.913l-87.723-629.602h79.499l66.706 542.792 75.845-469.689h96.861l72.189 469.689 74.93-542.792h73.103z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M737.071 474.992h233.93v64.879h-233.93v222.965h286.929v63.965h-365.516v-629.602h357.291l-9.138 65.793h-269.567z"
  })));
  return output;
}
